import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';
import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase/app';
import { GymInfo } from '../../_models/_firebaseObjects/GymInfo';


@Injectable()
export class AuthService {
  token = localStorage.getItem('auth_token');

  constructor(public firebaseAuth: AngularFireAuth, public db: AngularFireDatabase) {}

  signUpUser(email: string, password: string): Promise<firebase.auth.UserCredential> {
    return this.firebaseAuth.auth.createUserWithEmailAndPassword(email, password);
  }

  signUpGym(gym: GymInfo) {
    const dataToUpdate = {
      'Gym Address' : gym.gymAddress,
      'Gym Name' : gym.gymName,
      'active' : 1,
      'contactNumber': gym.contactNumber,
      'email': gym.email,
      'gymID': gym.gymID,
      'gymUID': gym.gymUID,
      'lat': gym.lat,
      'long': gym.long,
      'personName': gym.personName,
      'createdOn': new Date(),
      'createdBy': gym.gymID,
      'updatedOn': new Date(),
      'updatedBy': gym.gymID
    }
    return this.db.list('gyms').update(gym.gymID, dataToUpdate);
  }

  signInUser(email: string, password: string) {
    const promise = this.firebaseAuth.auth.signInWithEmailAndPassword(email, password);
    promise.then(
      user => console.log(user)
    );
    return promise;
  }

  sendEmailVerification(email: string) {
    const actionCodeSettings = {
      url: 'https://newdashboard-e08f1.firebaseapp.com/login',
      handleCodeInApp: true,
    }
    const user = this.firebaseAuth.auth.currentUser;
    return user.sendEmailVerification(actionCodeSettings);
  }

  logout(): Promise<void> {
    return this.firebaseAuth.auth.signOut();
  }

  getToken() {
    return localStorage.getItem('auth_token');
  }

  isAuthenticated() {
    // here you can check if user is authenticated or not through his token
    return this.getToken() !== null && this.getToken() !== undefined;
  }

  isUserEmailVerified() {
    return this.firebaseAuth.auth.currentUser &&
      this.firebaseAuth.auth.currentUser.emailVerified;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/auth/auth.service.ts